export enum enumIsfShipmentType {
  FORMAL = 1,
  INFORMAL = 11,
}
